module.exports = __webpack_public_path__ + "img/banner_2.b61feaf4.png";